import { OgpApiService } from 'ogp/services/ogp-api-service';
import { FlexWorkerProfileData } from '@types';
import { AddProposalPayload } from '../../shared/services/placement-service.types';

export class PlacementService {
  constructor(private readonly ogpApiService: OgpApiService) {}

  public async cancelPlacement(placementId: string) {
    const response = await this.ogpApiService.create<void>({
      path: `placements/${placementId}/cancel`,
    });

    return response;
  }

  public async terminatePlacement(placementId: string) {
    const response = await this.ogpApiService.create<void>({
      path: `placements/${placementId}/terminate`,
    });

    return response;
  }

  public async completePlacement(placementId: string) {
    const response = await this.ogpApiService.create<void>({
      path: `placements/${placementId}/complete`,
    });

    return response;
  }

  public async downloadContract(placementId: string) {
    const response = await this.ogpApiService.create({
      path: `placements/contract`,
      body: {
        placementId,
      },
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/pdf',
      },
      decoder: (arrayBuffer: any) => new Blob([arrayBuffer], { type: 'application/pdf' }),
    });

    return response;
  }

  public async settleCheckouts(checkoutIds: string[]) {
    const response = await this.ogpApiService.create<string[]>({
      path: 'placements/checkouts/settle',
      body: {
        checkoutIds,
      },
    });

    return response;
  }

  public async addProposal(placementId: string, checkoutId: string, payload: AddProposalPayload) {
    const response = await this.ogpApiService.create<void>({
      path: `placements/${placementId}/checkouts/${checkoutId}/add-proposal`,
      body: payload,
    });

    return response;
  }

  public async getFlexWorkerProfileThroughPlacement(placementId: string, flexWorkerId: string) {
    const response = await this.ogpApiService.get<FlexWorkerProfileData>({
      path: `placements/${placementId}/profile/${flexWorkerId}`,
    });
    return response;
  }
}
